import React from 'react'
import NavLink from '../Routes/NavLink'

export default class DashboardShortcutsWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    QuickAction = (props) => {
        return(
            <ul class="nav">
                <li>
                    <NavLink to={props.route}>
                        <div class="qa-row">
                            <div class ="qa-icon">
                                <i class={props.icon}></i>
                            </div>
                            <div class="qa-title">
                                    <p style={{ lineHeight: "15px" }}>
                                        {props.title}
                                    </p>
                            </div>
                        </div>
                    </NavLink>
                </li>
            </ul>
        );
    }

    QuickActionRow = (props) => {
        return (
            <div className="quick-row">
                { props.children }
            </div>
        )
    }

    render() {
        let QuickAction = this.QuickAction
        let QuickActionRow = this.QuickActionRow
        return (
            <div class="card">
                <div class="row">
                    <div class="header">
                        <h4 class="title">Quick Actions</h4>
                        <p class="category">Shortcuts for your convenience</p>
                    </div>
                    <div class="content settings-list">
                        <div class="qa-grid">
                            <QuickAction route="/maintenance/order/new" icon="icon-wrench-outline" title="Add Maintenance Request" />
                            <QuickAction route="/tenant/new" icon="icon-person-outline" title="Add Tenant" />
                            <QuickAction route="/tenant/charge/new" icon="icon-credit-card-slot" title="Charge Tenant" />
                            <QuickAction route="/lease/new" icon="icon-paper-outline" title="Add Lease" />
                            <QuickAction route="/properties/new" icon="icon-house-outline" title="Add Property" />
                            <QuickAction route="/reports" icon="icon-menu-chart-outline" title="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Shortcuts/DashboardShortcutsWidget.jsx